// extracted by mini-css-extract-plugin
export var checkboxStylesOverride = "zzprG";
export var checkmarkStyles = "s0NVw";
export var indeterminateOrCheckedStyle = "Ksdin";
export var selectedMessageCheckboxStyle = "i7xzh";
export var squareCheckbox = "gy2XW";